<template>
  <div v-if="crossSaleVehicles.length > 0" class="extravehicle">
    <ul class="extravehicle__list">
      <li v-for="vehicle in this.crossSaleVehicles" class="card card--horizontal" :key="vehicle.rangeId">
        <div class="card__group">
          <img :src="imageUrl(vehicle)" />
          <span class="card__header"> {{vehicle.manufacturerName}} {{vehicle.rangeName}}
          </span>
        </div>
        <div class="card__cross" @click="removeVehicleFromArray(vehicle)"></div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import Vehicle from '@/models/vehicle/vehicle';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';

const VehicleManagementModule = namespace('vehicleManagementModule');

@Component
export default class PresubXsaleVehiclesComponent extends Vue {
  @VehicleManagementModule.Getter public extraVehicles!: IVehicle[];

  @VehicleManagementModule.Action public submitRemoveExtraVehicle;

  public imageUrl(vehicle: Vehicle) {
    if (vehicle !== null) {
      if (vehicle.images.basic.length === 0) {
        return this.manufacturerLogo(vehicle);
      }
      return `//image.uk-tla.com/api/v1/image/vehicle/${vehicle.vehicleType}/${vehicle.manufacturerNameSlug}/${vehicle.rangeNameSlug}/basic/${vehicle.images.basic[0].imageId}/70`;
    }

    return '';
  }

  public manufacturerLogo(vehicle: Vehicle) {
    if (vehicle !== null) {
      return `//image.uk-tla.com/api/v1/image/vehicle/${vehicle.vehicleType}/${vehicle.manufacturerNameSlug}/logo/62`;
    }

    return '';
  }

  public get crossSaleVehicles(): IVehicle[] {
    return this.extraVehicles;
  }

  public removeVehicleFromArray(vehicle: Vehicle) {
    this.submitRemoveExtraVehicle(vehicle);
  }
}
</script>
